<template>
  <ModalStep
    id="objective-description"
    :header="{
      title: attachedDataRef.title,
    }"
    :onExitHandler="closeModal"
  >
    <template #headerBeforeElement>
      <button class="modal-close-button" @click="closeModal" type="button" data-test-id="objective-description-close-button">
        <CrossIcon color="white" />
      </button>
    </template>
    <template #headerAfterElement>
      <div class="objective-badge">
        {{ t('dashboard.shared.programObjectives.objectiveNumber', { number: attachedDataRef.order + 1 }) }}
      </div>
    </template>

    <template #bodyContent>
      <div
        class="objective-description-modal-content"
        data-test-id="objective-description-modal-content"
        v-html="attachedDataRef.description"
      ></div>
    </template>
  </ModalStep>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import ModalStep from '@/features/ui/components/modal/modal-step/modal-step.vue'
import CrossIcon from '@/features/ui/components/icons/cross-icon.vue'
import { selectGetObjectiveDescriptionModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'
import { useI18n } from '@/lib/i18n'

const { t } = useI18n()

const objectiveDescriptionModalRef = selectGetObjectiveDescriptionModal(modalsStore)
const attachedDataRef = computed(() => objectiveDescriptionModalRef.value.attachedData)

function closeModal() {
  modalsStore.toggleModal('objective-description', false)
}
</script>

<style lang="scss">
@import './objective-description-modal-content.scss';
</style>
